module.exports = __webpack_public_path__ + "static/img/icon_done.f3d8ed3e.png";